import { render, staticRenderFns } from "./OpacitySlider.vue?vue&type=template&id=18b63f13&scoped=true&"
import script from "./OpacitySlider.vue?vue&type=script&lang=js&"
export * from "./OpacitySlider.vue?vue&type=script&lang=js&"
import style0 from "./OpacitySlider.vue?vue&type=style&index=0&id=18b63f13&scoped=true&lang=css&"
import style1 from "./OpacitySlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b63f13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
